export default __webpack_public_path__ + "signup-type-selection-bg-0263c9e763c6626c33398ae5fe4c6925.jpg";